import request from '@/utils/request'


// 获得与真专属套餐
export function getExclusivePackage(id) {
  return request({
    url: '/yuzhen/exclusive-package/get?id=' + id,
    method: 'get'
  })
}

// 获得与真专属套餐分页
export function getExclusivePackagePage(query) {
  return request({
    url: '/yuzhen/exclusive-package/page',
    method: 'get',
    params: query
  })
}

